const state = {
	token: null,
	// 用户对象
	user: {},
}

const getters = {
	token: state => {
		if (state.token) {
			return state.token;
		}
		state.token = localStorage.getItem('artwormz-token');
		return state.token;
	},
	user: state => {
		if (state.user) {
			return state.user;
		}
		state.user = JSON.parse(localStorage.getItem('artwormz-user'));
		return state.user;
	},
}

const actions = {
	tokenHandler(context, payload){
		context.commit('tokenHandler', payload);
	},
	userHandler(context, payload){
		context.commit('userHandler', payload);
	},
}

const mutations = {
	tokenHandler(state, token){
		if(token == null){
			localStorage.removeItem('artwormz-token');
		} else {
			localStorage.setItem('artwormz-token', token);
		}
		state.token = token;
	},
	userHandler(state, user){
		localStorage.setItem('artwormz-user', JSON.stringify(user));
		state.user = user;
	},
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user/index.js